import { DB } from '@/extensions/db'
import { Device } from './device'
import { newGuid } from '../utils'

let instance = null

export class ModbusDevice {
  constructor () {
    instance = instance || this

    this._table = DB.modbusDevice
    this._device = new Device()

    return instance
  }

  /**
   * @param [string] options.name
   * @param [string] options.address
   * @param [string] options.interfaceType
   * @param [string] options.interface
   * @param [string] options.module
   *
   * @returns [number] device id
   */
  async add (data) {
    let id = await this._device.add({ type: 'modbus' })
    data = JSON.parse(JSON.stringify(data))
    return this._table.add(Object.assign({}, data, {
      id: data._id || newGuid(),
      deviceId: id
    }))
  }

  async get (id) {
    return this._table.get(id)
  }

  async update (id, data) {
    return this._table.update(id, data)
  }

  async delete (id) {
    let deviceId = (await this.get(id)).deviceId

    await this._device.delete(deviceId)
    return this._table.delete(id)
  }

  async all () {
    return this._table.toArray()
  }

  async interfaceId (id) {
    return this._table.where({ interface: id }).toArray()
  }
}



// WEBPACK FOOTER //
// ./src/models/modbus-device.js